<template>
  <div class="py-4 pos-relative">
    <div class="container">
      <div class="row">
        <div class="col-md-7 text-dark">
          <h1 class="fw-extrabold header-top text-poppins">{{ $t('free_for_everyone') }}</h1>
          <h2 class="fw-extrabold header-top text-poppins">+ {{ $t('we_help_you') }}</h2>
          <div class="mt-5">
            <router-link :to="distributeNowLink" class="btn btn-lg btn-success text-poppins">{{ $t('distribute_now') }}</router-link><br/>
            <!-- <div class="fw-bold mt-1 mb-4">{{ $t('fast_simple') }}</div> -->
          </div>
        </div>
        <div class="col-md-5">
          <img src="/static/img/landing/computer2.png" alt="Indiefy Distribution Platform" class="img-fluid mt-4 mb-4">
        </div>
      </div>
      <div class="pos-relative mt-3 bar-container">
        <div class="py-2 bg-primary bar animated fadeIn animation-delay-400"></div>
      </div>
      <div class="text-center mt-5">
        <h3 class="fw-bold text-dark text-poppins">{{ $t('sell_your_music_on') }}</h3>
        <div class="row justify-content-md-center mt-2 stores-row">
          <div class="col-4 col-md-2">
            <img src="/static/img/landing/stores/0-transparent.png" alt="Spotify Distribution" class="img-fluid">
          </div>
          <div class="col-4 col-md-2">
            <img src="/static/img/landing/stores/1-transparent.png" alt="Apple Music Distribution" class="img-fluid">
          </div>
          <div class="col-4 col-md-2">
            <img src="/static/img/landing/stores/2-transparent.png" alt="Deezer Distribution" class="img-fluid">
          </div>
          <div class="col-4 col-md-2">
            <img src="/static/img/landing/stores/3-transparent.png" alt="Beatport Distribution" class="img-fluid">
          </div>
          <div class="col-4 col-md-2">
            <img src="/static/img/landing/stores/4-transparent.png" alt="YouTube Distribution" class="img-fluid">
          </div>
          <div class="col-4 col-md-2">
            <img src="/static/img/landing/stores/7-transparent.png" alt="Amazon Distribution" class="img-fluid">
          </div>
        </div>
        <p class="mb-5 text-muted">
          {{ $t('and_many_platforms') }}
        </p>
      </div>
      <div class="text-right pt-3 text-dark tools-description clearfix">
        <div class="fw-extrabold pull-right text-poppins">
          {{ $t('we_provide_you') }}
        </div>
      </div>
      <div class="row mt-5 features-row">
        <div class="col-md-4">
          <img src="/static/img/landing/presave.jpg" alt="Presave Campaigns" class="img-fluid">
          <div class="h2 fw-bold text-dark mt-2 text-poppins">
            {{ $t('presave_campaigns') }}
          </div>
          <p class="mt-3 mb-3">
            {{ $t('landing_presave_description') }}
          </p>
        </div>
        <div class="col-md-4">
          <router-link to="/services">
            <img src="/static/img/landing/playlisting.jpg" alt="Playlist Placement" class="img-fluid">
          </router-link>
          <div class="h2 fw-bold text-dark mt-2 text-poppins">
            {{ $t('playlist_placement') }}
          </div>
          <p class="mt-3 mb-3">
            {{ $t('landing_placement_description') }}
          </p>
        </div>
        <div class="col-md-4">
          <img src="/static/img/landing/network.jpg" alt="Indiefy Network" class="img-fluid">
          <div class="h2 fw-bold text-dark mt-2 text-poppins">
            Indiefy Network
          </div>
          <p class="mt-3 mb-3">
            {{ $t('landing_network_description') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LandingDistribution',
  data: function () {
    return {
      distributeNowLink: '/login',
      lang: 'en',
      words: [],
      currentWord: 0
    }
  },
  methods: {
    getLoginUrl: function (identifier) {
      let baseUrl = ''

      if (location.host.match(/free-music-distribution/)) {
        baseUrl = 'https://indiefy.net'
      }

      if (this.$user && this.$user._id) {
        return `${baseUrl}/dashboard`
      } else {
        if (navigator.userAgent.match(/bot|googlebot|prerender|crawler|spider|robot|crawling/i)) {
          return `${baseUrl}/login`
        }

        if (identifier) {
          return `${baseUrl}/login?from=${identifier}`
        }
        return `${baseUrl}/login`
      }
    },
    animateText: function () {
      let i = 0
      let txt = this.words[this.currentWord]
      let speed = 100

      if (!this.$refs.word) {
        return
      }

      this.$refs.word.innerHTML = ''

      const typeWriter = () => {
        if (i < txt.length && this.$refs.word) {
          this.$refs.word.innerHTML += txt.charAt(i)
          i++
          setTimeout(typeWriter, speed)
        } else {
          this.currentWord++

          if (this.currentWord > (this.words.length - 1)) {
            this.currentWord = 0
          }

          setTimeout(() => {
            this.animateText()
          }, 1000)
        }
      }

      typeWriter()
    }
  },
  mounted: function () {
    this.animateText()

    setTimeout(() => {
      window.prerenderReady = true
    }, 100)
  },
  created: function () {
    if (this.$i18n) {
      this.lang = this.$i18n.locale
    }

    this.words = [
      this.$t('easy'),
      this.$t('cool'),
      this.$t('fast'),
      this.$t('amazing'),
      this.$t('simple')
    ]

    window.document.title = this.$t('landing_title')
    window.$('meta[property="og:title"]').attr('content', this.$t('landing_title'))
    window.$('meta[name="description"]').attr('content', this.$t('landing_description'))
    window.$('meta[property="og:description"]').attr('content', this.$t('landing_description'))
  }
}
</script>
<style lang="scss" scoped>
.header-top {
  margin-bottom: 0;
  font-size: 2.5em;
}

.bar {
  position: absolute;
  top: 55%;
  left: -100%;
  width: 300%;
}

.bar-container {
  height: 10px;
}

.all-need {
  font-size: 18px;
}

.tools-description .fw-extrabold {
  font-size: 2em;
  max-width: 50%;
}

.features-row {
  img {
    border-radius: 3px;
  }
}

@media screen and (min-width:320px) and (max-width:576px) {
  .tools-description .fw-extrabold {
    max-width: 80% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LandingDistribution.vue